export default (opts = {}) => {
    const component = {
        model: {
            defaults: {
              tagname:'div', 
              name: "Div",
              attributes: { class: 'w-100 gap-60 d-flex  d-sm-column wrap' },
              components: [
               {
                type:'cardDifferences1',
               },
               {
                type:'cardDifferences1',
               },
               {
                type:'cardDifferences1',
               },
               {
                type:'cardDifferences1',
               },
               {
                type:'cardDifferences1',
               },
               {
                type:'cardDifferences1',
               },
      
              ],
              styles: `
               .d-flex{
                display:flex; 
                flex-direction:row; 
               }
               .gap-60{
                gap:60px;
               }
               .w-100{
                width:100%; 
               }
               .wrap{
                flex-wrap: wrap; 
               }
               @media (max-width:992px){
                .d-sm-column{
                  flex-direction: column !important; 
                }
              }
            `,
             },
          },
          view: {
      
          },
};
  return component; 
};